import React from "react";
import { Box, Typography } from "@mui/material";

// Piezas que comparten las pantallas de RRHH I: lista de nóminas, detalle, recibo por empleado
// y puestos.

// Lo que devuelve `errorResponse` cuando el servidor dice que la sesión sigue abierta en otro equipo.
export const ERROR_OTRA_SESION = "Sesión activa en otro dispositivo";

// Sin tildes y sin mayúsculas, para que "Quincena" se encuentre escribiendo "quincena" o "QUINCENA".
export const normalizar = (texto) =>
  String(texto ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

// Encabezado de tabla: texto en primary, en negrita y sin partirse en dos líneas.
export const encabezadoTabla = {
  fontWeight: 700,
  color: "primary.main",
  whiteSpace: "nowrap",
};

// Columnas de montos: a la derecha y con cifras tabulares.
export const celdaMonto = {
  textAlign: "right",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};

export const celdaFecha = {
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};

// Estado de una nómina para `EstadoChip`. Los ids son los del servidor: 1 = ABIERTA, 2 = CERRADA.
// La abierta usa `info` para que se distinga de las cerradas, que quedan en `neutro`.
export const estadoDeNomina = (estado) => {
  if (estado?.id === 1) return { estado: "info", label: "Abierta" };
  if (estado?.id === 2) return { estado: "neutro", label: "Cerrada" };
  return { estado: "neutro", label: estado?.description || "Sin estado" };
};

export const nominaAbierta = (nomina) => nomina?.estado?.id === 1;
export const nominaCerrada = (nomina) => nomina?.estado?.id === 2;

// Una pareja etiqueta/valor de una lista de datos (`dl`).
export const Dato = ({ etiqueta, children }) => (
  <Box component="div" sx={{ minWidth: 0 }}>
    <Typography
      component="dt"
      variant="caption"
      sx={{ display: "block", color: "text.secondary", fontWeight: 700 }}
    >
      {etiqueta}
    </Typography>
    <Box component="dd" sx={{ m: 0, mt: 0.5, overflowWrap: "anywhere" }}>
      {children}
    </Box>
  </Box>
);
